import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=16d1b7ea&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=js&"
export * from "./Reviews.vue?vue&type=script&lang=js&"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=16d1b7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1b7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d1b7ea')) {
      api.createRecord('16d1b7ea', component.options)
    } else {
      api.reload('16d1b7ea', component.options)
    }
    module.hot.accept("./Reviews.vue?vue&type=template&id=16d1b7ea&scoped=true&", function () {
      api.rerender('16d1b7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Reviews.vue"
export default component.exports